{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"name": "core/math",
	"title": "Math",
	"category": "text",
	"description": "Display mathematical notation using LaTeX.",
	"keywords": [ "equation", "formula", "latex", "mathematics" ],
	"textdomain": "default",
	"supports": {
		"anchor": true,
		"html": false,
		"__experimentalBorder": {
			"color": true,
			"radius": true,
			"style": true,
			"width": true
		},
		"color": {
			"gradients": true,
			"__experimentalDefaultControls": {
				"background": true,
				"text": true
			}
		},
		"spacing": {
			"margin": true,
			"padding": true,
			"__experimentalDefaultControls": {
				"margin": false,
				"padding": false
			}
		},
		"typography": {
			"fontSize": true,
			"__experimentalDefaultControls": {
				"fontSize": true
			}
		}
	},
	"attributes": {
		"latex": {
			"type": "string",
			"role": "content"
		},
		"mathML": {
			"type": "string",
			"source": "html",
			"selector": "math"
		}
	}
}
